var exports = {
  "uK": "GiftPlutoniumModal.module__option___U0dRY3",
  "fS": "GiftPlutoniumModal.module__optionName___U0dRY3",
  "$f": "GiftPlutoniumModal.module__optionPrice___U0dRY3",
  "f2": "GiftPlutoniumModal.module__saving___U0dRY3",
  "N4": "GiftPlutoniumModal.module__note___U0dRY3",
};

module.exports = exports;
